import axios from "axios";
import { SSO_API_BASE_URL, SSO_REFRESH_TOKEN } from "./endpoints";

export interface SsoRefreshTokenPayload {
  refreshToken: string;
}

export interface SsoRefreshTokenResponse {
  status: number;
  accessToken: string;
  expiresAt: string;
  refreshToken: string;
  refreshTokenExpiresAt: string;
  applications?: unknown;
  operatorId?: string;
  name?: string;
  location?: string;
}

export async function ssoRefreshToken(
  payload: SsoRefreshTokenPayload
): Promise<SsoRefreshTokenResponse> {
  const response = await axios.post<SsoRefreshTokenResponse>(
    SSO_API_BASE_URL + SSO_REFRESH_TOKEN,
    payload,
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
}
